import { render, staticRenderFns } from "./addProductSeckill.vue?vue&type=template&id=6be8bbc3"
import script from "./addProductSeckill.vue?vue&type=script&lang=js"
export * from "./addProductSeckill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports